import { useAuth } from "./useAuth";
import { supabase } from "@/integrations/supabase/client";
import { useState, useEffect } from "react";

/**
 * Hook to check user role and permissions
 * Fetches role directly from database to avoid circular dependencies
 */
export function useRole() {
  const { user } = useAuth();
  const [role, setRole] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchRole = async () => {
      if (!user) {
        setRole(null);
        setIsLoading(false);
        return;
      }

      try {
        const { data, error } = await supabase
          .from("profiles")
          .select("*")
          .eq("user_id", user.id)
          .maybeSingle();

        if (error) {
          console.error("Error fetching role:", error);
          setRole(null);
        } else {
          const profile = data as { role?: string | null } | null;
          setRole(profile?.role || null);
        }
      } catch (err) {
        console.error("Error fetching role:", err);
        setRole(null);
      } finally {
        setIsLoading(false);
      }
    };

    fetchRole();
  }, [user]);

  const isAdmin = role === "DiscoRun";
  const isManager = role === "Manager" || isAdmin;
  const isViewer = role === "Viewer" || isManager;
  const isPAR = role === "PAR";

  return {
    role,
    isLoading,
    isAdmin,
    isManager,
    isViewer,
    isPAR,
  };
}
